export const getStyles = () => ({
  accountModeSubtitle: {
    textAlign: 'center',
    lineHeight: '19px',
    margin: 0,
    '& a.account-mode-comparison-link': {
      textDecoration: 'underline',
    },
    '& a.account-mode-comparison-link:hover': {
      color: '#0078d4',
    },
  },
  accountModeContainer: {
    width: '530px',
    marginTop: 32,
    '& a:hover': {
      textDecoration: 'none',
      color: '#0078d4',
    },
  },
  accountModeSelectionContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },

  accountModeSkipContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    borderTop: '1px solid #F2F2F2',
    padding: '4px 0',
    fontSize: '14px',
    lineHeight: '20px',
    textAlign: 'center',
    flexWrap: 'wrap',
    justifyContent: 'center',
    '& .account-mode-skip-link': {
      textDecoration: 'underline',
      margin: '0 4px',
    },
    '& .account-mode-skip-link:hover': {
      color: '#0078d4',
    },
  },

  // size s classes
  'accountModeSelectionContainer-s': { flexDirection: 'column' },
  'accountModeContainer-s': { width: '272px' },
  'accountModeSkipContainer-s': {
    display: 'block',
    '& .account-mode-skip-link': {
      margin: 0,
      marginRright: '4px',
    },
  },
  // size m classes
  'accountModeSelectionContainer-m': { flexDirection: 'column' },
  'accountModeContainer-m': { width: '382px' },
});

export const getIntroStyles = () => ({
  introContainer: {
    marginTop: 32,
    marginBottom: 16,

    '& .intro-title': {
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '20px',
    },

    '& .intro-body': {
      marginTop: 10,
      paddingRight: 15,
      fontSize: '14px',
      lineHeight: '25px',

      '& ul': {
        paddingLeft: '25px',
      },
    },
    'introContainer-s': { width: '272px' },
    'introContainer-m': { width: '382px' },
  },
});

const modeItemMarginRight = '16px';

export const getBulletItemStyles = () => ({
  bulletItem: {
    display: 'flex',
    marginTop: 8,
  },
  iconContainer: {
    marginRight: '10px',
    width: '20px',
    height: '20px',
  },
});

export const bulletItemStyles = {
  text: {
    root: {
      textAlign: 'start',
      fontSize: '14px',
      color: '#616161',
      lineHeight: '18px',
    },
  },
};

export const getModeItemStyles = () => ({
  itemContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: `calc((100% - ${modeItemMarginRight}) / 2)`,
  },
  recommended: {
    width: 'fit-content',
    display: 'inline-block',
    padding: '0px 14px',
    fontSize: '10px',
    lineHeight: '20px',
    height: '20px',
    fontWeight: 600,
    borderRadius: '4px 4px 0 0',
    color: '#fff',
    background: 'linear-gradient(102.36deg, #0A1B45 17.63%, rgba(27, 62, 115, 0.882169) 63.53%, rgba(43, 88, 156, 0.775808) 96.63%), #0A1B45',
  },
  recommendedNotSelected: {
    background: '#828282 !important',
  },
  recommendedNotVisible: {
    visibility: 'hidden',
  },
  item: {
    width: '100%',
    flex: '1',
    display: 'flex',
    alignItems: 'start',
    flexFlow: 'column',
    backgroundColor: '#fff !important',
    padding: '16px',
    border: '2px solid',
    borderRadius: '4px',
    position: 'relative',
    minHeight: 151,
    '& > span': {
      fontSize: 14,
    },
  },
  itemRecommended: {
    borderRadius: '0px 4px 4px 4px',
  },
  optionSelected: {
    borderColor: '#0078D4',
  },
  optionNotSelected: {
    borderColor: 'transparent',
    boxShadow: '0px 1.6px 3.6px rgba(0, 0, 0, 0.132), 0px 0.3px 0.9px rgba(0, 0, 0, 0.108)',
  },
  description: {
    fontSize: '14px',
    textAlign: 'start',
    color: '#616161',
    lineHeight: '18px',
    margin: '8px 0px',
  },
  rebrandingSelectedDescription: {
    border: '1px solid #B4D6FA',
    borderRadius: '4px',
    padding: '4px 8px',
    color: '#115EA3',
    backgroundColor: '#EBF3FC',
  },
  rebrandingNotSelectedDescription: {
    border: '1px solid #E0E0E0',
    borderRadius: '4px',
    padding: '4px 8px',
    color: '#616161',
    backgroundColor: '#F0F0F0',
  },
  icon: {
    color: '#0078D4',
    fontSize: '25px',
    position: 'absolute',
    top: '11px',
    right: '14px',
  },
  divider: {
    backgroundColor: '#EDEBE9',
    height: 1,
    width: '100%',
    margin: '7px 0px',
  },
  // size s classes
  'itemContainer-s': {
    width: '100%',
    '& .item': {
      minHeight: 0,
    },
  },

  // size m classes
  'itemContainer-m': {
    width: '100%',
    '& .item': {
      minHeight: 0,
    },
  },

  // size l classes
  'itemContainer-l': {
    width: '100%',
    '& .item': {
      minHeight: 0,
    },
  },

});

export const modeItemStyles = {
  title: { root: { fontWeight: 600, fontSize: '18px', lineHeight: '24px' } },
  image: { root: { marginBottom: 4, minHeight: 40 } },
  bulletsTitle: {
    root: {
      fontWeight: 600,
      marginTop: 4,
      textAlign: 'start',
      fontSize: '14px',
      color: '#616161',
      lineHeight: '18px',
    },
  },
  text: {
    root: {
      marginTop: 4,
      textAlign: 'start',
      fontSize: '14px',
      color: '#616161',
      lineHeight: '18px',
    },
  },
};
